import { useSetRecoilState } from 'recoil'
import { SubscriptionsTable } from 'src/views/subscriptions/table'
import { SUBSCRIPTION_UPDATE_STEPS } from 'src/atoms/payments'

import * as paymentsAtoms from 'src/atoms/payments'

export const PaymentPlans = () => {
  const setActiveStep = useSetRecoilState(paymentsAtoms.subscriptionUpdateStep)

  // Since this is for free to paid there is no concept of a downgrade
  const onNext = async () => {
    setActiveStep(SUBSCRIPTION_UPDATE_STEPS.PAYMENT)
  }

  return <SubscriptionsTable onDowngrade={onNext} onUpgrade={onNext} />
}
